var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIIcon = function SvgIIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.416 10a6.584 6.584 0 1 1 13.169 0 6.584 6.584 0 0 1-13.169 0M10 2.415a7.584 7.584 0 1 0 0 15.169 7.584 7.584 0 0 0 0-15.169m.5 4.252a.5.5 0 0 0-1 0v4.583a.5.5 0 0 0 1 0zm0 6.655a.5.5 0 0 0-1 0v.011a.5.5 0 1 0 1 0z",
    clipRule: "evenodd"
  })));
};
export default SvgIIcon;